import { message } from "antd";
import axios, { AxiosError } from "axios";
import { errorActions } from "../helpers/auth_helper";

export const createPI = async (value: any) => {
  try {
    return axios
      .post("https://api-dev.materialdepot.in/apiV1/estimate/", value)
      .then((res) => {
        message.success("PI created succesfully");
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error creating PI. Please try again.");
        return false;
      });
  } catch (error) {
    return false;
  }
};

export const refundOrder = async (value: any) => {
  try {
    return axios
      .post("/refund/", value)
      .then((res) => {
        message.success("Order refund created succesfully");
        return res?.data;
      })
      .catch((error) => {
        console.log({ error });
        errorActions(
          error,
          "Error creating refund." + { error }.error?.response?.data
        );
        return false;
      });
  } catch (error) {
    return false;
  }
};

export const getOrderRefunds = async (params: any) => {
  try {
    return axios
      .get(`/refund/`, {
        params: { ...params },
      })
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error getting refunds. Please try again.");
        return false;
      });
  } catch (error) {
    return false;
  }
};

export const triggerGSTRetrofit = async (
  estimate_id: number,
  address_id: number,
  gst_no: string,
  company_name?: string
): Promise<{ retrofit_id: number } | false> => {
  try {
    return axios
      .post("/estimate-gst-retrofit/", {
        estimate_id,
        address_id,
        gst_no,
        company_name,
      })
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Failed to initiate GST retrofit. Please try again.");
        return false;
      });
  } catch {
    return false;
  }
};

export const editPI = async (pi_id: any, params: any, force_update: boolean = false, asAdmin = false) => {
  try {
    return axios
      .put(
        `/estimate/${pi_id}/`,
        params,
        {
          params: {
            ...(asAdmin ? {} : { from_procurement: "true" }),
            force_update: force_update.toString(),
          },
        }
      )
      .then((res) => {
        message.success("PI edited succesfully");
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error editing PI. Please try again.");

        return false;
      });
  } catch (error) { }
};

export const editProFormaInvoiceItem = async (
  id: number | string,
  data: Record<string, string | number>
) => {
  try {
    const response = await axios.put("/estimate-item/" + id + "/", data);
    return response.data;
  } catch (e) {
    errorActions(e as AxiosError, "Could not update PI item. Try again.");
    return null;
  }
};

export const editVariantHSNCode = async (
  variant_id: number,
  hsn_code: string
) => {
  try {
    return axios
      .put(
        `/variant-single-update-hsn-code/?variant_id=${encodeURIComponent(
          variant_id
        )}&hsn_code=${encodeURIComponent(hsn_code)}`
      )
      .then((res) => {
        message.success("HSN code updated succesfully");
      })
      .catch((error) => {
        errorActions(error, "Error updating HSN code. Please try again.");
        return;
      });
  } catch (error) { }
};

export const fetchProFormaInvoices = async (params: any) => {
  try {
    return axios
      .get(`/estimate-info/`, {
        params: { ...params, is_revised: false },
      })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorActions(error, "Error fetching PI. Please try again.");
        return;
      });
  } catch (error) {
    return [];
  }
};

export const fetchPIfromId = async (pi_id: string) => {
  try {
    return axios
      .get(`/estimate/`, {
        params: { id: pi_id },
      })
      .then((res) => {
        return res.data?.results[0];
      })
      .catch((error) => {
        errorActions(error, "Error fetching PI. Please try again.");
        return;
      });
  } catch (error) {
    return [];
  }
};

export const fetchPIfromLeadId = async (lead_id: string) => {
  try {
    return axios
      .get(`/estimate/`, {
        params: { lead_id, is_revised: false, is_deleted: false },
      })
      .then((res) => {
        return res.data?.results[0];
      })
      .catch((error) => {
        errorActions(error, "Error fetching PI. Please try again.");
        return;
      });
  } catch (error) {
    return [];
  }
};

export const checkAndConfirmOrderPayment = async (
  pi_id: string,
  showMessage = true
) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/order-payment-status/`, {
        params: { estimate_id: pi_id },
      })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (showMessage) {
          errorActions(error, "Payment not done");
        }
        return;
      });
  } catch (error) {
    return [];
  }
};

export const fetchPIRevisions = async (lead_id: string) => {
  try {
    return axios
      .get(`/estimate-revision/`, {
        params: { lead_id: lead_id },
      })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorActions(error, "Error fetching PI revisions. Please try again.");
        return;
      });
  } catch (error) {
    return [];
  }
};

export const fetchEstimateLogs = async (estimate_id: string) => {
  try {
    return axios
      .get(`/estimate-log/`, {
        params: { estimate: estimate_id },
      })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorActions(error, "Error fetching PI logs. Please try again.");
        return;
      });
  } catch (error) {
    return [];
  }
};

export const fetchEstimateLogsByLeadId = async (lead_id: string) => {
  try {
    return axios
      .get(`/estimate-log/`, {
        params: { estimate__lead_id: lead_id },
      })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorActions(error, "Error fetching PI logs. Please try again.");
        return;
      });
  } catch (error) {
    return [];
  }
};

export const createEstimateDuplicate = (estimate_id: string) => {
  return axios
    .get(
      `/estimate-duplicate/?estimate_id=${estimate_id}`
    )
    .then((res) => {
      return true;
    })
    .catch((error) => {
      errorActions(error, "Error duplicating estimate. Please try again.");
      return false;
    });
};

export const caluclateShippingPorterFromAddress = (payload: any) => {
  try {
    return axios
      .post(
        "/md-shipping-cal/",
        payload,
        {
          headers: {
            Authorization: `Basic ODk3OTk5NzA3MjptZEAwNTY4Iw==`,
          },
        }
      )
      .then((res) => {
        message.success(
          "Calculated Delivery charges approx: ₹" +
          (res?.data).toFixed(0) +
          ". Check and confirm with delivery team."
        );
        return res?.data;
      })
      .catch((error) => {
        errorActions(
          error,
          "Error in calculating delivery charges. Please fill it manually."
        );
        return false;
      });
  } catch (error) {
    return false;
  }
};

export const caluclateShippingCourierFromAddress = (payload: any) => {
  try {
    return axios
      .post(
        "/md-courier-cost-cal/",
        payload,
        {
          headers: {
            Authorization: `Basic ODk3OTk5NzA3MjptZEAwNTY4Iw==`,
          },
        }
      )
      .then((res) => {
        message.success(
          "Calculated Delivery charges approx: ₹" +
          (res?.data).toFixed(0) +
          ". Check and confirm with delivery team."
        );
        return res?.data;
      })
      .catch((error) => {
        errorActions(
          error,
          "Error in calculating delivery charges. Please fill it manually."
        );
        return false;
      });
  } catch (error) {
    return false;
  }
};

export async function getShippingChargesFromPincode(
  estimate_items: any,
  ship_pincode: any,
  total_amount: any,
  estimate_id: any
) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/master-shipping/`,
      {
        // Adding method type
        method: "POST",

        // Adding body or contents to send
        body: JSON.stringify({
          estimate_items,
          ship_pincode,
          total_amount,
          estimate_id,
        }),

        // Adding headers to the request
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `JWT ${localStorage.getItem("token")}`,
        },
      }
    );
    return await response.json();

    // const response = await axios.post(
    //   "https://apiv2..materialdepot.in//master-shipping/",
    //   {
    //     estimate_items,
    //     ship_pincode,
    //   },
    //   {
    //     headers: {
    //       Accept: "application/json",
    //     },
    //   }
    // );
    // return response.data;
  } catch (error) {
    return false;
  }
}

export async function getZoneFromPincode(pincode: any) {
  try {
    const response = await axios.get(
      `/pincode/?pincode=${pincode}`
    );
    return response.data;
  } catch (error) {
    return false;
  }
}

export const createOrderFromPI = async (estimate_id: string) => {
  try {
    return axios
      .get(
        `/push-estimate-order?estimate_id=` +
        estimate_id
      )
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        message.error("Some error occured");

        errorActions(error, "Error fetching PI revisions. Please try again.");
        return;
      });
  } catch (error) {
    return [];
  }
};

export const addInvoiceToPFI = async (value: any) => {
  try {
    return axios
      .post("/estimate-invoice/", value)
      .then((res) => {
        message.success("Invoice added succesfully");
      })
      .catch((error) => {
        errorActions(error, "Error adding Invoice. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error adding Invoice. Please try again.");
    return null;
  }
};

export const getPFIInvoices = async (estimate_id: any) => {
  try {
    return axios
      .get(
        "/estimate-invoice/?estimate=" +
        estimate_id
      )
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error creating PO. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error creating PO. Please try again.");
    return null;
  }
};

export const removeInvoiceFromPI = async (id: any) => {
  try {
    return axios
      .delete("/estimate-invoice/" + id + "/")
      .then((res) => {
        message.success("Invoice removed succesfully");
      })
      .catch((error) => {
        errorActions(error, "Error removing invoice. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error creating PO. Please try again.");
    return null;
  }
};

export const pushEstimateToZoho = async (id: any) => {
  message.loading({ content: "Pushing PI to Zoho", key: "pushZohoPI" });
  return axios
    .get("/zoho-invoice/", {
      params: { estimate_id: id },
    })
    .then((res) => {
      // message.success("PI pushed to Zoho succesfully");
      message.success({
        content: "PI pushed to Zoho succesfully",
        key: "pushZohoPI",
      });
      return res?.data;
    })
    .catch((error) => {
      // errorActions(error, "Error pushing PI to Zoho. Please try again.");
      message.error({
        content: "Error pushing PI to Zoho. Please try again.",
        key: "pushZohoPI",
      });
      return false;
    });
};

export const getCouponList = async (user_id?: string) => {
  try {
    return axios
      .get("/coupon-list/", user_id ? { params: { user_id } } : undefined)
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error creating PO. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error creating PO. Please try again.");
    return null;
  }
};

export const getCouponDiscount = async (value: any) => {
  try {
    return axios
      .post(
        "/estimate-validate-coupon/",
        value
      )
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Error creating PO. Please try again.");
        return;
      });
  } catch (error) {
    message.error("Error creating PO. Please try again.");
    return null;
  }
};

export const validateSiteAuditEnq = async (value: any) => {
  try {
    return axios
      .post("/estimate-validate-site-audit-enq/", value)
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(error, "Could not validate the Site Audit ENQ ID.");
        return null;
      });
  } catch (error) {
    return null;
  }
};

export interface EstimateFeedbackBase {
  remarks: string;
  in_store_exp_rating: number;
  delivery_rating: number;
  sales_interaction_rating: number;
  // Format: YYYY-MM-DD
  photoshoot_date: string | null;
}
export interface EstimateFeedbackRead extends EstimateFeedbackBase {
  id: number;
  estimate: any;
  created_at: string;
  modified_at: string;
}
export interface EstimateFeedbackCreate extends EstimateFeedbackBase {
  estimate_id: string;
}

export function getEstimateFeedback(
  id: string
): Promise<Array<EstimateFeedbackRead>> {
  return axios
    .get<Array<EstimateFeedbackRead>>(
      `/estimate-feedback/`,
      {
        params: { estimate_id: id },
      }
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error fetching feedback. Please try again.");
      return [] as Array<EstimateFeedbackRead>;
    });
}

export function createEstimateFeedback(
  feedback: EstimateFeedbackCreate
): Promise<EstimateFeedbackRead> {
  return axios
    .post<EstimateFeedbackRead>(
      `/estimate-feedback/`,
      feedback
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error creating feedback. Please try again.");
      return null as any;
    });
}

export function updateEstimateFeedback(
  feedback: EstimateFeedbackCreate,
  id: number
): Promise<EstimateFeedbackRead> {
  return axios
    .put<EstimateFeedbackRead>(
      `/estimate-feedback/?id=${id}`,
      feedback
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error updating feedback. Please try again.");
      return null as any;
    });
}

export function getEstimateTransactions(estimate_id: number) {
  return axios
    .get(
      `/estimate-payment-transaction/?estimate_id=${estimate_id}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error fetching transactions. Please try again.");
      return null;
    });
}

export function createEstimateTransaction(data: any) {
  return axios
    .post(
      `/estimate-payment-information/`,
      data
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error creating transaction. Please try again.");
      return null;
    });
}

export function createPinelabTransaction(data: any) {
  // //pinelab-transaction/
  return axios
    .post(`/pinelab-transaction/`, data)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error creating transaction. Please try again.");
      return null;
    });
}

export function getPinelabTransaction(transaction_id: number) {
  // //pinelab-transaction/
  return axios
    .get(
      `/pinelab-transaction/?transaction_id=${transaction_id}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error creating transaction. Please try again.");
      return null;
    });
}

export function cancelPinelabTransaction(transaction_id: number) {
  // //pinelab-transaction/
  return axios
    .delete(
      `/pinelab-transaction/?transaction_id=${transaction_id}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error creating transaction. Please try again.");
      return null;
    });
}

// //estimate-additional-charge-reverse-raised-for/
export const getEstimateAdditionalChargesReverseRaisedFor = async (
  params: any
) => {
  try {
    return axios
      .get(
        "/estimate-additional-charge-reverse-raised-for/",
        {
          params: { ...params },
        }
      )
      .then((res) => {
        return res?.data;
      });
  } catch (error) {
    return null;
  }
};

// /raise-refund-po-for-entire-estimate/
export const raiseRefundPOForEntireEstimate = async (params: {
  estimate_id: number | string;
  [key: string]: any;
}) => {
  try {
    return axios
      .post(
        "/raise-refund-po-for-entire-estimate/",
        {
          ...params,
        }
      )
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        return null;
      });
  } catch (error) {
    return null;
  }
};

// //estimate-item-po-raised-for/
export const getEstimateItemPORaisedFor = async (params: {
  estimate_id: any;
}) => {
  try {
    return axios
      .get(
        "/estimate-item-po-raised-for/",
        {
          params: { ...params },
        }
      )
      .then((res) => {
        return res?.data;
      });
  } catch (error) {
    return null;
  }
};

// //estimate-additional-charge-refund-raised-for/
export const getEstimateAdditionalChargeRefundRaisedFor = async (params: {
  estimate_id: any;
}) => {
  try {
    return axios
      .get(
        "/estimate-additional-charge-refund-raised-for/",
        {
          params: { ...params },
        }
      )
      .then((res) => {
        return res?.data;
      });
  } catch (error) {
    return null;
  }
};

// Add express delivery charge
export const addExpressDeliveryCharge = async (params: {
  estimate_id: string | number;
  express_charge: number;
  operation_type?: string;
  payment_type?: string;
  payment_reference?: string | number;
  organisation_branch_id?: string | number;
  remark?: string;
}) => {
  try {
    return axios
      .post("/add-express-delivery-charge/", {
        estimate_id: params.estimate_id,
        express_charge: params.express_charge,
        operation_type: params.operation_type,
        payment_type: params.payment_type,
        payment_reference: params.payment_reference,
        organisation_branch_id: params.organisation_branch_id,
        remark: params.remark,
      })
      .then((res) => {
        const successMessage = params.operation_type === "remove"
          ? "Express delivery charge removed successfully"
          : "Express delivery charge added successfully";
        message.success(successMessage);
        return res?.data;
      })
      .catch((error) => {
        const responseBody = error?.response?.data;
        if (responseBody?.error) {
          message.error(responseBody.error);
        } else {
          const errormessage = params.operation_type === "remove"
            ? "Error removing express delivery charge. Please try again."
            : "Error adding express delivery charge. Please try again.";
          errorActions(error, errormessage);
        }
        return false;
      });
  } catch (error) {
    return false;
  }
};

// Add unloading charges
export const addUnloadingCharge = async (params: {
  estimate_id: string | number;
  unloading_charge: number;
  operation_type?: string;
  payment_type?: string;
  payment_reference?: string | number;
  organisation_branch_id?: string | number;
  remark?: string;
}) => {
  try {
    return axios
      .post("/add-unloading-charge/", {
        estimate_id: params.estimate_id,
        unloading_charge: params.unloading_charge,
        operation_type: params.operation_type,
        payment_type: params.payment_type,
        payment_reference: params.payment_reference,
        organisation_branch_id: params.organisation_branch_id,
        remark: params.remark,
      })
      .then((res) => {
        const successMessage = params.operation_type === "remove"
          ? "Unloading charges removed successfully"
          : "Unloading charges added successfully";
        message.success(successMessage);
        return res?.data;
      })
      .catch((error) => {
        const errormessage = params.operation_type === "remove"
          ? "Error removing unloading charges. Please try again."
          : "Error adding unloading charges. Please try again.";
        errorActions(error, errormessage);
        return false;
      });
  } catch (error) {
    return false;
  }
};

// Add standard transport charges ("Transport Charges" / "Standard Delivery")
export const addDeliveryCharge = async (params: {
  estimate_id: string | number;
  delivery_charge: number;
  operation_type?: string;
  payment_type?: string;
  payment_reference?: string | number;
  organisation_branch_id?: string | number;
  remark?: string;
}) => {
  try {
    return axios
      .post("/add-delivery-charge/", {
        estimate_id: params.estimate_id,
        delivery_charge: params.delivery_charge,
        operation_type: params.operation_type,
        payment_type: params.payment_type,
        payment_reference: params.payment_reference,
        organisation_branch_id: params.organisation_branch_id,
        remark: params.remark,
      })
      .then((res) => {
        const successMessage = params.operation_type === "remove"
          ? "Transport charges removed successfully"
          : "Transport charges added successfully";
        message.success(successMessage);
        return res?.data;
      })
      .catch((error) => {
        const responseBody = error?.response?.data;
        if (responseBody?.error) {
          message.error(responseBody.error);
        } else {
          const errormessage = params.operation_type === "remove"
            ? "Error removing transport charges. Please try again."
            : "Error adding transport charges. Please try again.";
          errorActions(error, errormessage);
        }
        return false;
      });
  } catch (error) {
    return false;
  }
};

// Add a free-form charge described by its remark (stored as "Additional Charges")
export const addOtherCharge = async (params: {
  estimate_id: string | number;
  amount: number;
  remark: string;
  payment_type?: string;
  payment_reference?: string | number;
  organisation_branch_id?: string | number;
}) => {
  try {
    return axios
      .post("/add-other-charge/", params)
      .then((res) => {
        message.success("Charge added successfully");
        return res?.data;
      })
      .catch((error) => {
        const responseBody = error?.response?.data;
        if (responseBody?.error) {
          message.error(responseBody.error);
        } else {
          errorActions(error, "Error adding charge. Please try again.");
        }
        return false;
      });
  } catch (error) {
    return false;
  }
};

// Remove one additional charge from a PI that hasn't been placed yet
export const removeEstimateCharge = async (params: {
  estimate_id: string | number;
  charge_id: string | number;
}) => {
  try {
    return axios
      .post("/remove-estimate-charge/", params)
      .then((res) => {
        message.success("Charge removed successfully");
        return res?.data;
      })
      .catch((error) => {
        const responseBody = error?.response?.data;
        if (responseBody?.error) {
          message.error(responseBody.error);
        } else {
          errorActions(error, "Error removing charge. Please try again.");
        }
        return false;
      });
  } catch (error) {
    return false;
  }
};

export const getPinelabsDetails = async (branch_id: number) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/pinelab-branch-details?branch_id=${branch_id}`)
    return res?.data;
  } catch (error) {
    return null;
  }
}

// Razorpay POS (Ezetap) APIs

export function createRazorpayPosTransaction(data: any) {
  return axios
    .post(`/razorpay-pos-transaction/`, data)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error creating Razorpay POS transaction. Please try again.");
      return null;
    });
}

export function getRazorpayPosTransaction(transaction_id: number) {
  return axios
    .get(`/razorpay-pos-transaction/?transaction_id=${transaction_id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error fetching Razorpay POS transaction status.");
      return null;
    });
}

export function cancelRazorpayPosTransaction(transaction_id: number) {
  return axios
    .delete(`/razorpay-pos-transaction/?transaction_id=${transaction_id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error cancelling Razorpay POS transaction.");
      return null;
    });
}

export const getEzetapBranchDetails = async (branch_id: number) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/ezetap-branch-details/?branch_id=${branch_id}`)
    return res?.data;
  } catch (error) {
    return null;
  }
}

export const getEzetapEnabledBranchIds = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/ezetap-branch-details/`)
    if (!Array.isArray(res?.data)) return null;
    return Array.from(
      new Set(
        res.data
          .map((mapping: any) => mapping?.branch)
          .filter((id: any) => id !== null && id !== undefined)
      )
    ) as number[];
  } catch (error) {
    return null;
  }
}

export const fetchPaymentSummary = async (estimate_id: string | number) => {
  try {
    const res = await axios.get(`/estimate-payment-summary/?estimate_id=${estimate_id}`);
    return res?.data;
  } catch (error) {
    return null;
  }
};

export const refundEstimateItems = async (payload: {
  estimate_id: number;
  items: { estimate_item_id: number; quantity: number }[];
  reason: string;
}) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/refund-estimate-items/`,
      payload
    );
    return res?.data;
  } catch (error: any) {
    errorActions(error, "Failed to refund estimate items. Please try again.");
    return null;
  }
};

export const refundServiceInvoice = async (estimate_id: string | number) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/refund-service-invoice/`,
      { estimate_id }
    );
    return res?.data;
  } catch (error: any) {
    errorActions(error, "Failed to refund service invoice. Please try again.");
    return null;
  }
};

export const fetchWalletBalance = async (client_id: string | number) => {
  try {
    const res = await axios.get(`/wallet-balance/?client_id=${client_id}`);
    return res?.data;
  } catch (error) {
    return null;
  }
};

// The client's FULL wallet history — every WalletTransaction row across every source
// (PG top-up, Zoho CN refund, cash) and every status, including rows whose spendable
// balance has drained to zero. `/wallet-balance/` above only returns spendable rows
// and is what the payment flows consume; this endpoint is what the client-details
// ledger view opens to show how the current balance was arrived at.
export interface WalletLedgerEntry {
  id: number;
  source: "PG_TOPUP" | "ZOHO_CN" | "CASH";
  status: "INITIATED" | "SUCCESS" | "FAILED";
  amount: string;
  spent_amount: string;
  available_balance: string;
  to_be_refunded_amount: string;
  refunded_amount: string;
  reference_type: string | null;
  reference_id: string | null;
  payment_id: string | null;
  payment_method: string | null;
  payment_date: string | null;
  created_at: string;
  sales_order: { id: number; zoho_salesorder_number: string | null } | null;
  created_by: string | null;
}

export const fetchWalletLedger = async (
  client_id: string | number
): Promise<{ transactions: WalletLedgerEntry[] } | null> => {
  try {
    const res = await axios.get(`/wallet-ledger/?client_id=${client_id}`);
    return res?.data;
  } catch (error) {
    return null;
  }
};

// Manually admit an existing Zoho credit note into a client's wallet.
// Backend verifies CN.customer_id matches this client and that the CN has not already been
// credited. Errors are RE-THROWN so the caller can render the backend's `error` message
// (e.g. "CN belongs to a different customer", "CN is already accounted for in a wallet")
// verbatim in the modal — the whole point of this button is to surface those.
export const admitCnToWallet = async (
  client_id: string | number,
  cn_id: string
): Promise<{ id: number; amount: string; available_balance: string; payment_id: string }> => {
  const res = await axios.post("/wallet-ledger/admit-cn/", { client_id, cn_id });
  return res.data;
};

// Earmark part / all of a wallet row's spendable balance for a customer-bank payout. Adds to
// `to_be_refunded_amount` and subtracts the same from `available_balance`; the Cash Log Refunds
// tab reads the earmark + the chosen bank account when ops executes the actual bank transfer.
// Partial refund rule: a second call on the same row ADDS to the existing earmark rather than
// replacing it (so a 300-balance row refunded 150 then 50 ends at available 100 / earmarked 200).
// Errors re-thrown so the caller renders the backend's `detail` message verbatim in the modal.
export interface WalletRefundToCustomerResponse {
  wallet_tx_id: number;
  earmarked_amount: string;          // paise, additive this call
  available_balance: string;         // paise, after this call
  to_be_refunded_amount: string;     // paise, cumulative earmark
}

export const walletRefundToCustomer = async (
  wallet_tx_id: number,
  input: { amount_paise: string | number; bank_details_id?: number | null; note?: string }
): Promise<WalletRefundToCustomerResponse> => {
  const res = await axios.post(
    `/oms/refunds/${wallet_tx_id}/refund-to-customer/`,
    input
  );
  return res.data;
};

export const addCashToWallet = async (data: any) => {
  try {
    const res = await axios.post("/wallet-transaction/", data);
    return res?.data;
  } catch (error: any) {
    errorActions(error, "Error adding cash to wallet. Please try again.");
    return null;
  }
};

export const fetchWalletTransactions = async (client_id: string | number) => {
  try {
    const res = await axios.get(`/wallet-transaction/?client_id=${client_id}`);
    return res?.data;
  } catch (error) {
    return [];
  }
};

export const fetchWalletCashTopUps = async (params?: { client_id?: string | number }) => {
  try {
    const res = await axios.get("/wallet-cash-top-ups/", { params });
    return res?.data;
  } catch (error) {
    return [];
  }
};

export const approveWalletCashTopUp = async (id: number) => {
  try {
    const res = await axios.post(`/wallet-cash-approve/${id}/`);
    return res?.data;
  } catch (error: any) {
    errorActions(error, "Error approving wallet top-up. Please try again.");
    return null;
  }
};

export const settleWalletTransactions = async (payload: {
  estimate_id: number;
  client_id: number | string;
  organisation_branch_id?: number | null;
}) => {
  try {
    const res = await axios.post("/settle-wallet-transactions/", payload);
    return res?.data;
  } catch (error: any) {
    errorActions(error, "Error settling wallet transactions. Please try again.");
    return null;
  }
};